import { Injectable } from '@angular/core'

import { UserDto, PageResultDto, FindUserDto, CreateUserDto, UpdateUserDto } from '../dto'

import { HttpService } from './http.service'

@Injectable()
export class UserService {
  constructor(
    private httpService: HttpService) {
  }

  async create(createUserDto: CreateUserDto) {
    return this.httpService.post<UserDto>('/admin/users/', createUserDto)
  }

  async find(findUserDto: FindUserDto) {
    return await this.httpService.get<PageResultDto<UserDto>>('/admin/users', findUserDto)
  }

  async findOne(id: string) {
    return await this.httpService.get<UserDto>(`/admin/users/${id}`)
  }
  
  async update(id: string, updateUserDto: UpdateUserDto) {
    return await this.httpService.put<UserDto>(`/admin/users/${id}`, updateUserDto)
  }

  async destroy(id: string) {
    return await this.httpService.delete<boolean>(`/admin/users/${id}`)
  }

  async updatePassword(id: string, password: string) {
    return await this.httpService.post<UserDto>(`/admin/users/${id}/password`, {password})
  }

  async setEnabled(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.put(`/admin/users/${id}/enable`)
    }
    
    return await this.httpService.put(`/admin/users/${id}/disable`)
  }
}
